import { colors } from '@lmc/common/constants'
import { isNumber } from 'lodash'
import styled from 'styled-components'
import { LabelIcon } from '../../LabelIcon'

const StyledCell = styled.div<{ $clickable: boolean }>`
  display: flex;
  justify-content: center;
  ${({ $clickable }) => $clickable && 'cursor: pointer;'}
`

interface ActualStockCellProps {
  actualStock: number
  deleted?: boolean
  expectedStock?: number
  onSelect?: () => void
  showExpectedStock?: boolean
}

export default function ActualStockCell({
  actualStock,
  deleted,
  expectedStock,
  onSelect,
  showExpectedStock
}: ActualStockCellProps) {
  if (deleted) return null

  const alert = expectedStock !== actualStock
  const iconName =
    isNumber(expectedStock) && isNumber(actualStock) && showExpectedStock
      ? alert
        ? 'overdue'
        : 'tick-in-circle'
      : null

  return (
    <StyledCell $clickable={!!onSelect} onClick={onSelect}>
      <LabelIcon
        iconFill={alert ? colors.orange : colors.successgreen}
        iconName={iconName}
        iconPosition="right"
        iconSize={24}
        text={actualStock}
      />
    </StyledCell>
  )
}
